import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import RouteResolverService from 'src/app/domain/service/route-resolver/route-resolver.service';
import {Bootstrap} from 'src/app/infrastructure/bootstrap/bootstrap';
import {AppEnvironmentService} from 'src/app/infrastructure/environment/app-environment/app-environment.service';
import {Router} from 'src/app/infrastructure/router/router';
import {Modal} from 'src/app/infrastructure/service/modal.service';
import {WebPage} from 'src/app/ui/webapp/page/web.page';

@Component({
  selector: 'app-internal-server-error',
  templateUrl: 'internal-server-error.page.html',
})
export class InternalServerErrorPage extends WebPage {
  public retrying = false;
  private fromBootstrap = false;

  constructor(
    private routeResolver: RouteResolverService,
    private modal: Modal,
    private bootstrap: Bootstrap,
    private route: ActivatedRoute,
    router: Router,
    appEnvironment: AppEnvironmentService,
    titleService: Title
  ) {
    super(router, appEnvironment, titleService);
  }

  onInit(): void {
    super.onInit();
    this.modal.dismiss();
    this.fromBootstrap = this.route.snapshot.queryParamMap.get('from') === 'bootstrap';
  }

  async refresh(): Promise<void> {
    if (!this.fromBootstrap) {
      this.navigate(this.routeResolver.resolve());
      return;
    }

    this.retrying = true;
    try {
      const ok = await this.bootstrap.checkForAppUpdates();
      if (ok) {
        this.navigate(this.routeResolver.resolve());
      }
    } finally {
      this.retrying = false;
    }
  }
}
